import Vue from 'vue'
import VueRouter from 'vue-router'
// 判断是否是云端稿库
const isRR = process.env.MODE === 'RR'
// 判断是否是PUGC投稿平台
const isPUGC = process.env.MODE === 'PUGC'
Vue.use(VueRouter)

export const routes = [
  /**
   * 首页默认重定向到登录页(废弃)
   * 根路径重定向到首页
   */
  {
    path: '/',
    redirect: isRR || isPUGC ? '/login' : '/home'
  },
  /**
   * 首页，门户页
   */
  {
    path: '/home',
    name: 'Home',
    component: isPUGC
      ? () => import('../views/Pugc/Layout/index')
      : () => import('../views/Home/homes')
  },
  //在智能媒资环境申请下来前以固定路由访问用于演示
  {
    path: '/znmz',
    name: 'znmz',
    component: () => import('../views/Home/theme/znmz.vue')
  },
  /**
   * 首页，门户页
   */
  {
    path: '/homes',
    name: 'Homes',
    component: () => import('../views/Home')
  },
  /**
   * 自动登录中转页
   */
  {
    path: '/autoLogin',
    name: 'AutoLogin',
    component: () => import('../views/AutoLogin')
  },
  /**
   * 登录页
   * 通过导航守卫拦截和请求拦截器重定向进入
   */
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login')
  },
  {
    path: '/service/*',
    name: 'service',
    component: isPUGC
      ? () => import('../views/Pugc/Layout/index')
      : () => import('../views/Portal/index'),
    children: [
      {
        path: 'vPortal',
        name: 'vPortal',
        component: () => import('../views/VPortal')
      }
    ]
  },
  {
    path: '/open/*',
    name: 'open',
    component: () => import('../views/NewWindow/index')
  },
  {
    path: '/v-portal',
    name: 'portal',
    component: () => import('../views/Portal/index'),
    children: [
      {
        path: 'vPortal',
        name: 'vPortal',
        component: () => import('../views/VPortal')
      }
    ]
  },
  /**
   * 公告详情
   */
  {
    path: '/noticeDetail',
    name: 'NoticeDetail',
    component: () => import('../views/Home/components/noticeDetail')
  },
  /**
   * 错误页
   */
  {
    path: '/error',
    name: 'Error',
    component: () => import('../views/Error')
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('../views/NotFound')
  }
]

export const router = new VueRouter({
  mode: 'history',
  routes
})
